// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Lenis from 'lenis';

// ============================================
// Lenis
// ============================================
export let lenis = new Lenis({
  lerp: 0.12,
  duration: 1.6,
  smoothWheel: true,
  smoothTouch: false,
});

//初期設定
lenis.on('scroll', ScrollTrigger.update);
const _raf = (time) => lenis.raf(time * 1000);
gsap.ticker.add(_raf);
gsap.ticker.lagSmoothing(1000, 16);

const REINIT_MS = 60 * 1000;
setInterval(() => {
  gsap.ticker.remove(_raf);
  lenis.destroy();

  lenis = new Lenis({
    lerp: 0.1,
    duration: 1.0,
    smoothWheel: true,
    smoothTouch: true,
  });

  lenis.on('scroll', () => ScrollTrigger.update());
  gsap.ticker.add(_raf);
  ScrollTrigger.refresh();
}, REINIT_MS);

// ============================================
// ページ内リンク
// ============================================
function lenisPageScroll() {
  const links = document.querySelectorAll('a[href^="#"]:not(.-no-smooth, .l-header__skip-content)');
  if (links.length === 0) return;

  const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');
  const headerHeightNum = headerHeight.split('px')[0];

  links.forEach((target) => {
    target.addEventListener('click', (e) => {
      e.preventDefault();
      let targetLink = target.getAttribute('href');
      if (targetLink === '#') {
        targetLink = 'body';
      }

      lenis.scrollTo(targetLink, {
        offset: Number(headerHeightNum) * -1,
        lerp: 0.2,
        duration: 1.2,
      });
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  ScrollTrigger.batch('.js-inview', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

export { lenisPageScroll, inViewAnm };
